import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';

interface Props {
  onUpdate: () => void;
  onDelete: () => void;
}

const ListActionButtons = ({ onUpdate, onDelete }: Props) => (
  <Stack direction={'row'} spacing={1}>
    <IconButton size="small" onClick={onUpdate}>
      <Edit sx={{ fontSize: 18 }} />
    </IconButton>
    <IconButton size="small" onClick={onDelete}>
      <Delete sx={{ fontSize: 18 }} />
    </IconButton>
  </Stack>
);

export default ListActionButtons;
